import React from 'react';
const StaffDirectoryElement = () => <div className="builder-staff" style={{padding:'1rem',border:'1px dashed #ccc'}}>👥 Staff Directory (Coming Soon)</div>;
export default StaffDirectoryElement;
